import { Label } from "@/components/ui/label";
import { CustomSwitchProps } from "./type";
import { Switch } from "../ui/switch";

const CustomSwitch = (props: CustomSwitchProps): React.ReactElement => {
  const {
    id,
    label,
    className,
    thumCss,
    parentBlockCss,
    checked,
    onCheckedChange,
    disabled,
    size,
  } = props;
  return (
    <div
      className={`switch-wrapper flex flex-none flex-row-reverse items-center gap-2 ${parentBlockCss}`}
    >
      <Label
        htmlFor={id}
        className="hover:cursor-pointer !font-normal relative"
      >
        {label}
      </Label>

      <Switch
        id={id}
        className={className ?? ""}
        thumbCss={thumCss ?? ""}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        size={size}
      />
    </div>
  );
};

export default CustomSwitch;
